import { Alert, Button, Segment } from "@simplybusiness/mobius";
import { useState } from "react";
import { ResyncConfirmationModal } from "./ResyncConfirmationModal";
import type { PromptContentProps } from "./types";

export const PromptContent = ({
  prompt,
  onPromptAction,
  isPromptActionLoading = false,
  onRemoveProduct,
  isRemoveLoading = false,
}: PromptContentProps) => {
  const [isResyncDialogOpen, setIsResyncDialogOpen] = useState(false);

  const isResyncPrompt = prompt.type === "resync";
  const handleActionButtonPress = isResyncPrompt
    ? () => setIsResyncDialogOpen(true)
    : () => onPromptAction?.();

  return (
    <Segment
      colour="subtle"
      className="mobius-payment-options mobius-payment-options--prompt"
      data-testid="payment-options-prompt"
    >
      <div className="mobius-payment-options__prompt-content">
        <Alert header="Action required" variant="error">
          {prompt.message}
        </Alert>

        <Button
          variant="secondary"
          size="sm"
          className="mobius-payment-options__prompt-button"
          isLoading={isPromptActionLoading}
          isDisabled={isPromptActionLoading}
          onPress={handleActionButtonPress}
        >
          {prompt.buttonText}
        </Button>

        {isResyncPrompt && (
          <ResyncConfirmationModal
            isOpen={isResyncDialogOpen}
            isLoading={isPromptActionLoading}
            onConfirm={() => onPromptAction?.()}
            onClose={() => setIsResyncDialogOpen(false)}
          />
        )}

        <Button
          variant="ghost"
          size="sm"
          className="mobius-payment-options__prompt-button"
          isLoading={isRemoveLoading}
          isDisabled={isRemoveLoading}
          onPress={() => onRemoveProduct?.()}
        >
          Remove this coverage
        </Button>
      </div>
    </Segment>
  );
};
